import { Icon } from '@toggle/design-system';
import React from 'react';

import * as S from './AlertsIcon.styles';

export const AlertsIcon = () => {
  // TODO: update to get unread count from store
  const unreadCount = 12;

  return (
    <S.AlertsIconRoot>
      <Icon iconName="NotificationLine" size={24} />
      {unreadCount > 0 && <S.UnreadBadge>{unreadCount}</S.UnreadBadge>}
    </S.AlertsIconRoot>
  );
};
